<template>
    <div class="dividerContainer" :style="{height: dividerConfig.height, maxHeight:'300px'}">
        <span class="line" :style="{width:dividerConfig.width}"></span>
        <p class="content">{{dividerConfig.text}}</p>
        <span class="line" :style="{width:dividerConfig.width}"></span>
    </div>
</template>
<script>
export default {
    name:'BaseCardDivider',
    props:{
        dividerConfig:{
            type:Object,
            required:true
        }
    }
}
</script>
<style scoped>
    .dividerContainer{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .content{
        padding:0;
        margin:0;
    }
    .line{
        height: 100%;
        background: rgb(197, 197, 197);
    }
</style>